import {
  BackendError,
  BackendQueryKeys,
  useTypeSafeQuery,
} from '@oresundsbron/api';
import { Box } from '@oresundsbron/bridge-ui';
import { PrivateITicketOrderInputV2 } from '@oresundsbron/validators';
import { FC, useCallback, useEffect } from 'react';
import { EmbededReepay } from './EmbededReepay';

export const ITicketPayement: FC<{
  onSuccess: (data: Reepay.Response, session: string) => void;
  onError: (err: BackendError) => void;
  order?: PrivateITicketOrderInputV2;
}> = ({ onSuccess, onError, order }) => {
  const { data, error, isLoading, isError, refetch } = useTypeSafeQuery(
    BackendQueryKeys.ITicketPaymentSession(order as PrivateITicketOrderInputV2),
    (req) => req.ITicket.paymentSession(order as PrivateITicketOrderInputV2),
    {
      enabled: false,
      staleTime: 0,
      refetchOnMount: false,
    }
  );

  useEffect(() => {
    refetch();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!error) {
      return;
    }
    onError(error);
  }, [error, onError]);

  const _onSuccess = useCallback(
    (d: Reepay.Response) => onSuccess(d, data?.session as string),
    [data?.session, onSuccess]
  );

  if ((!data && !isError) || isLoading) {
    return (
      <Box className="item-center col-span-full flex h-[600px] items-center justify-center text-5xl text-primary-600 md:col-span-6 md:col-start-4">
        <svg
          className="animate-spin"
          fill="currentColor"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      </Box>
    );
  }

  return <EmbededReepay onSuccess={_onSuccess} token={data?.token} />;
};
